// AngularDevise
// -------------------
// v1.2.1
//
// Copyright (c)2016 Justin Ridgewell
// Distributed under MIT license
//
// https://github.com/cloudspace/angular_devise
!function (a) {
  "use strict";

  var b = a.module("Devise", []);
  b.provider("AuthIntercept", function () {
    var a = !1;
    this.interceptAuth = function (b) {
      return a = !!b || void 0 === b, this;
    }, this.$get = ["$rootScope", "$q", function (b, c) {
      return {
        responseError: function responseError(d) {
          var e = d.config.interceptAuth;

          if (e = !!e || a && void 0 === e, e && 401 === d.status) {
            var f = c.defer();
            return b.$broadcast("devise:unauthorized", d, f), f.reject(d), f.promise;
          }

          return c.reject(d);
        }
      };
    }];
  }).config(["$httpProvider", function (a) {
    a.interceptors.push("AuthIntercept");
  }]), b.provider("Auth", function () {
    function b(b, c, d) {
      var h = {
        method: f[b].toLowerCase(),
        url: e[b]
      };
      return c && (g ? (h.data = {}, h.data[g] = c) : h.data = c), a.extend(h, d), h;
    }

    function c(b, c) {
      a.forEach(b, function (a, d) {
        this[d + c] = function (a) {
          return void 0 === a ? b[d] : (b[d] = a, this);
        };
      }, this);
    }

    function d(a) {
      return function () {
        return a;
      };
    }

    var e = {
      login: "/users/sign_in.json",
      logout: "/users/sign_out.json",
      register: "/users.json",
      sendResetPasswordInstructions: "/users/password.json",
      resetPassword: "/users/password.json"
    },
        f = {
      login: "POST",
      logout: "DELETE",
      register: "POST",
      sendResetPasswordInstructions: "POST",
      resetPassword: "PUT"
    },
        g = "user",
        h = function h(a) {
      return a.data;
    };

    c.call(this, f, "Method"), c.call(this, e, "Path"), this.resourceName = function (a) {
      return void 0 === a ? g : (g = a, this);
    }, this.parse = function (a) {
      return "function" != typeof a ? h : (h = a, this);
    }, this.$get = ["$q", "$http", "$rootScope", function (a, c, e) {
      function f(a) {
        return j._currentUser = a, a;
      }

      function g() {
        f(null), j._promise = null;
      }

      function i(a) {
        return function (b) {
          return e.$broadcast("devise:" + a, b), b;
        };
      }

      var j = {
        _currentUser: null,
        parse: h,
        _promise: null,
        reset: function reset() {
          g(), j.currentUser();
        },
        login: function login(a, d) {
          var e = arguments.length > 0,
              g = j.isAuthenticated();
          return a = a || {}, c(b("login", a, d)).then(j.parse).then(f).then(function (a) {
            return e && !g ? i("new-session")(a) : a;
          }).then(i("login"));
        },
        logout: function logout(a) {
          var e = d(j._currentUser);
          return c(b("logout", void 0, a)).then(g).then(e).then(i("logout"));
        },
        register: function register(a, d) {
          return a = a || {}, c(b("register", a, d)).then(j.parse).then(f).then(i("new-registration"));
        },
        sendResetPasswordInstructions: function sendResetPasswordInstructions(a) {
          return a = a || {}, c(b("sendResetPasswordInstructions", a)).then(j.parse).then(i("send-reset-password-instructions-successfully"));
        },
        resetPassword: function resetPassword(a) {
          return a = a || {}, c(b("resetPassword", a)).then(j.parse).then(f).then(i("reset-password-successfully"));
        },
        currentUser: function currentUser() {
          return j.isAuthenticated() ? a.when(j._currentUser) : (null === j._promise && (j._promise = j.login()), j._promise);
        },
        isAuthenticated: function isAuthenticated() {
          return !!j._currentUser;
        }
      };
      return j;
    }];
  });
}(angular);